import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Form } from "antd";

import {
    usersSetModeUserModal,
    usersSetShowUserModal,
} from '../../../../store/actions/usersActions';

import AccountModal from "../../../../commons/components/AccountModal"
import AccountInput from "../../../../commons/components/AccountInput/index";
import AccountSelectSearch from "../../../../commons/components/AccountSelectSearch";
import Loading from "../../../../commons/components/loading";
import RolesSelect from "../../../../commons/components/RolesSelect";

import newUserModalModes from './newUserModalModes'
import Utils from "../../../../commons/utils/utils";
import Http from "../../../../commons/utils/Http";
import Message from "../../../../commons/utils/message";

function ModalUser({ onSave }) {
    const dispatch = useDispatch();
    const { showUserModal, modeUserModal } = useSelector((state) => state.users);
    const [loading, setLoading] = useState(false);

    const [email, setEmail] = useState("");
    const [errorEmail, setErrorEmail] = useState("");

    const [partner, setPartner] = useState({});
    const [errorPartner, setErrorPartner] = useState("");

    const [selectedRoles, setSelectedRoles] = useState([]);
    const [errorRoleSelect, setErrorRoleSelect] = useState("");

    const [partners, setPartners] = useState([]);

    const [roleTreeData, setRoleTreeData] = useState([]);
    const [roleTreeExpanded, setRoleTreeExpanded] = useState([]);

    useEffect(() => {
        getRoleTreeData();
    }, []);

    function searchPartners(search) {
        Http.get(`/partners/search?search=${search}`, Http.headers)
            .then(response => {
                const responseData = response.data
                if (!responseData.response.error) {
                    setPartners(formatSelectPartnersData(responseData.data));
                }
            }).catch(err => {
                setPartners([]);
            })
    }

    function getRoleTreeData() {
        setLoading(true);
        Http.get(`/roles/roles-and-applications`, Http.headers)
            .then(response => {
                const responseData = response.data
                if (!responseData.response.error) {

                    let applicationRoles = [];
                    responseData.data.map((dataItem) => {
                        if (dataItem.partner_scoped == true) {
                            let application = { title: dataItem.name, key: dataItem.id, id: dataItem.id };
                            let roles = [];
                            dataItem.roles.map((dataRole) => {
                                let role = { title: dataRole.name, key: dataItem.id + '-' +dataRole.id, id: dataRole.id }
                                roles.push(role);
                            })
                            application.children = roles;
                            applicationRoles.push(application);
                        }
                    })

                    setRoleTreeData(applicationRoles)
                    setLoading(false);
                }
            }).catch(err => {
                setRoleTreeData([]);
                setLoading(false);
            })
    }

    async function findUser(email) {
        try {
            let response = await Http.get(`/users/get-by?field=email&value=${email}`, Http.headers);
            return response.data;
        } catch (error) {

            const responseData = error.response ? error.response.data : null;

            if (responseData && responseData.response.status == 414) {
                return responseData.data;
            }

            Message.showError("Erro ao buscar usuário");
        }
    }

    async function insertUser(body) {
        try {
            let response = await Http.post(`/users`, body, Http.headers);
            return response;
        } catch (error) {
            if (error.response) {
                Message.showError(error.response.data.response.message);
            }
            else {
                Message.showError("Erro ao inserir usuário");
            }
        }
    }

    function formatSelectPartnersData(data) {
        let array = [];
        if (data) {
            data.forEach((dataItem) => {
                let item = {}
                if (dataItem.id != 1 && dataItem.trading_name != "PARCEIRO DEFAULT") {
                    item.label = `${dataItem.codparc + " - " + dataItem.trading_name}`;
                    item.value = dataItem.id;
                    array.push(item)
                }
            })
        }
        return array;
    }

    function validateForm() {
        let valid = true;

        if (!email) {
            setErrorEmail("Informe um e-mail");
            valid = false;
        } else if (!Utils.validateEmail(email)) {
            setErrorEmail("Informe um e-mail válido");
            valid = false;
        }

        if (!partner.value) {
            setErrorPartner("Informe um parceiro");
            valid = false;
        }

        if (selectedRoles.length == 0) {
            setErrorRoleSelect("Informe uma role");
            valid = false;
        }

        return valid;
    }

    function renderButtons() {
        if (modeUserModal == newUserModalModes.VIEW) {
            return (
                <button key="cancel" onClick={handleClear} className="ant-btn ant-btn-primary">Ok</button>
            )
        } else {
            return (
                <>
                    <button key="cancel" onClick={handleClear} className="ant-btn">Cancelar</button>
                    <button key="confirm" onClick={handleSave} className="ant-btn ant-btn-primary">Salvar</button>
                </>
            )
        }
    }

    async function handleSave() {
        if (validateForm()) {

            let body = {
                "email": email,
                "partner_id": partner.value,
            };

            let bodyRoles = [];
            roleTreeData.map((application) => {
                application.children.map((role) => {
                    if (selectedRoles.includes(role.key)) {
                        bodyRoles.push({
                            "partner_id": partner.value,
                            "application_id": application.id,
                            "role_id": role.id,
                        })
                    }
                })
            })
            body.roles = bodyRoles;

            setLoading(true);
            const responseFindUser = await findUser(email);
            if (responseFindUser.data && responseFindUser.data.id) {
                setErrorEmail("Já existe um usuário com este e-mail");
            } else if (responseFindUser.data.status && responseFindUser.data.status == 452) {
                setErrorEmail("Informe um e-mail válido");
            } else {
                const responseInsert = await insertUser(body);
                if (responseInsert.data && !responseInsert.data.response.error) {
                    Message.showSuccess(responseInsert.data.response.message);
                    onSave();
                    handleClear();
                }
            }
            setLoading(false);

        }
    }

    function handleClear() {
        dispatch(usersSetShowUserModal(false));
        dispatch(usersSetModeUserModal(null));

        setEmail(null);
        setErrorEmail("");

        setPartner({});
        setErrorPartner("");

        setSelectedRoles([]);
        setErrorRoleSelect("");

        setPartners([]);
        setRoleTreeExpanded([]);

        setLoading(false);
    }

    function handleOnSearchPartner(search) {
        searchPartners(search);
        setErrorPartner("");
    }

    function handleOnChangePartner(partnerId) {
        setPartner(partners.find(partner => partner.value == partnerId));
        setErrorPartner("");
    }

    function handleOnChangeEmail(input) {
        setEmail(input.target.value);
        setErrorEmail("");
    }

    function onRoleCheck(checkedKeys) {
        setSelectedRoles(checkedKeys);
        setErrorRoleSelect("");
    };

    function renderForm() {
        if (loading) {
            return (
                <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
                    <Loading width={50} height={50} />
                </div>
            )
        } else {
            return (
                <Form>
                    <Form.Item>
                        <AccountInput
                            placeholder={"E-mail"}
                            value={email}
                            onChange={(value) => handleOnChangeEmail(value)}
                            error={errorEmail} />
                    </Form.Item>
                    <Form.Item>
                        <AccountSelectSearch
                            placeholder={"Selecionar Parceiro"}
                            data={partners}
                            value={partner.label}
                            onSearch={handleOnSearchPartner}
                            onChange={handleOnChangePartner}
                            error={errorPartner}
                            showSearch={true}
                            allowClear={false}
                        />
                    </Form.Item>
                    <Form.Item>
                        <RolesSelect
                            checkable={true}
                            onCheck={onRoleCheck}
                            checkedKeys={selectedRoles}
                            expandedKeys={roleTreeExpanded}
                            treeData={roleTreeData}
                            error={errorRoleSelect}
                            onExpand={(items) => setRoleTreeExpanded(items)}
                        />
                    </Form.Item>
                </Form>
            )
        }
    }

    return (
        <AccountModal
            visible={showUserModal}
            title={"Criar novo usuário"}
            onCancel={handleClear}
            footer={renderButtons()}>
            {renderForm()}
        </AccountModal>
    )
}

export default ModalUser;

